// extracted by mini-css-extract-plugin
export var podcasts = "feed-module--podcasts--5702d";
export var spacer = "feed-module--spacer--753cf";
export var spin = "feed-module--spin--ec4c1";